import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'
import { ListingResponse } from '~in-app/types/api.dto'

import { OperatorGroupListQuery, OperatorGroups } from './types'

export const fetchOperatorGroupList = async (params?: { abortCtrl?: AbortController | AbortSignal, query?: OperatorGroupListQuery }) => {
  return wretchClient
    .url('/admin/1.0/operator-groups')
    .signal(params?.abortCtrl)
    .query(params?.query || {})
    .get()
    .json<ListingResponse<OperatorGroups>>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
export const fetchOperatorGroupDetails = async (params?: { abortCtrl?: AbortController | AbortSignal, id: string }) => {
  return wretchClient
    .url(`/admin/1.0/operator-groups/${params?.id}`)
    .signal(params?.abortCtrl)
    .get()
    .json<OperatorGroups>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const deleteOperatorGroup = async (id: string) => {
  return wretchClient
    .url(`/admin/1.0/operator-groups/${id}`)
    .delete()
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const addOperatorGroup = async (value: any) => {
  return wretchClient
    .url(`/admin/1.0/operator-groups`)
    .post(value)
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
export const updateOperatorGroup = async (value: any) => {
  return wretchClient
    .url(`/admin/1.0/operator-groups`)
    .put(value)
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}

export const updateOperatorGroupStatus = async (id: string, activeFlag: boolean) => {
  return wretchClient
    .url(`/admin/1.0/operator-groups/${id}/${activeFlag}`)
    .patch()
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`${parsedData.title}: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
